export default __webpack_public_path__ + "static/media/f-arrow.9a4acc0d.svg";